import { Color } from 'styles/types'
import Text from 'components/shared/Text'
import Icon from 'components/shared/Icon'
import { Wrapper } from './styles'

interface CustomInfoProps {
    children: React.ReactNode
    iconColor: Color
    textColor: Color
    backgroundColor: Color
}

const CustomInfo = ({
    children,
    iconColor,
    textColor,
    backgroundColor,
}: CustomInfoProps) => (
    <Wrapper
        direction="row"
        align="flex-start"
        gap={16}
        background={backgroundColor}
        justify="flex-start"
        isFullWidth
    >
        <Icon variant="tooltip" color={iconColor} />
        <Text variant="bodySmall" color={textColor} align="left" as="div">
            {children}
        </Text>
    </Wrapper>
)

export default CustomInfo
